module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "pt2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PT"
  }, [_vm._v("ARRIVAL")]), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_vm._v("We may prefer to think of ourselves as fallen angels, but in reality we are rising apes.")]), _vm._v(" "), _c('div', {
    staticClass: "PEPC-SP"
  }, [_c('p', {
    staticClass: "PEPC"
  }, [_c('span', {
    staticClass: "pepc-CAPS"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ESMOND")]), _vm._v(" "), _c('span', {
    staticClass: "pepc-CAPS"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ORRIS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f068acd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part2.vue
// module id = 78
// module chunks = 0